import { getYears } from '@/utils/vehicle'
import YearBtn from '@/components/shared/yearBtn'
import useTranslation from '@/hooks/useTranslation'
import { TbSearch } from 'react-icons/tb'

const SearchButton = ({ onSearchButtonClick, isSearchOpen, t }) => (
  <div>
    <YearBtn appearance="ghost" className="ml-10" onClick={onSearchButtonClick}>
      <TbSearch className="mr-10" />
      {isSearchOpen ? t('header_close', 'Close') : t('header_search', 'Search')}
    </YearBtn>
  </div>
)

const GenerationYearSelect = ({
  generation,
  availableYears,
  select,
  value,
  rtl,
  katashiki,
  onSearchButtonClick = () => {},
  isSearchOpen = false
}) => {
  const t = useTranslation()
  const allLabel = t('finding_vehicle_publications_filter_all').toUpperCase()

  if (!generation) {
    if (katashiki) {
      return (
        <div className={`${rtl ? 'flex-r' : 'flex-l'} mb-20`}>
          <div style={{ flexGrow: 1 }} />
          <SearchButton onSearchButtonClick={onSearchButtonClick} isSearchOpen={isSearchOpen} t={t} />
        </div>
      )
    }
    return <div />
  }
  const years = getYears(generation).filter(year => availableYears.includes(year))
  if (!years.length) return <div />
  const allIsActive = value && typeof value !== 'string'
  return (
    <div className={`${rtl ? 'flex-r' : 'flex-l'} mb-20`}>
      <div style={{ display: 'flex', flexGrow: 1 }}>
        <YearBtn isActive={allIsActive} onClick={() => select(generation)} className="ml-10 mr-10">
          {allLabel}
        </YearBtn>
        {years.map(y => {
          const isActive = value === y.toString()
          return (
            <YearBtn className="ml-10 mr-10" key={y} onClick={() => select(generation, y)} isActive={isActive}>
              {y}
            </YearBtn>
          )
        })}
      </div>
      <SearchButton onSearchButtonClick={onSearchButtonClick} isSearchOpen={isSearchOpen} t={t} />
    </div>
  )
}

export default GenerationYearSelect
